import { render, staticRenderFns } from "./discountDialog.vue?vue&type=template&id=2da671b2"
import script from "./discountDialog.vue?vue&type=script&lang=js"
export * from "./discountDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports